import { Plurals } from "../textInterfaces";

export const getCorrectPluralForm = (
  plurals: Record<string, string>,
  pluralForm: Plurals,
): string => {
  if (plurals[pluralForm] === undefined) {
    throw new Error(
      `You are attempting to pass the plural form "${pluralForm}", but it does not exist in the data. The data contains the following plural forms: ${Object.keys(
        plurals,
      )}`,
    );
  }
  return plurals[pluralForm];
};
